import Cookies from 'js-cookie';
import { notification } from 'antd';
import actions from './actions';
import axios from '../../utility/axios';

const {
  loginBegin,
  loginSuccess,
  loginErr,
  logoutBegin,
  logoutSuccess,
  logoutErr,
  signupErr,
  signupSuccess
} = actions;

const login = (data) => {
  return async (dispatch) => {
    try {
      dispatch(loginBegin())
      axios.post('/user/login', data)
        .then(res => {
          dispatch(loginSuccess(res.data))
          console.log(111)
          window.location = '/admin';
          // history.push("/admin");
        })
        .catch((err) => {
          notification.error({
            message: 'Oops',
            description: 'Your email or password is incorrect.'
          })
          dispatch(loginErr())
          console.log(err)
        });
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const logOut = () => {
  return async (dispatch) => {
    try {
      dispatch(logoutBegin());
      Cookies.remove('logedIn');
      dispatch(logoutSuccess(null));
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

const signUp = (data, cb) => {
  console.log('axios', axios)
  return async dispatch => {
    try {
      axios.post('/user', data)
        .then(res => {
          notification.success({
            message: 'Signup Success',
            description: `Welcome ${res.data.fullname}`
          })
          dispatch(signupSuccess)
          cb();
        })
        .catch(err => {
          notification.error({
            message: 'An issue occur',
            description: err.response.data.message
          })
        });
    } catch (err) {
      dispatch(signupErr(err));
    }
  }
}

export { login, logOut, signUp };
